// src/api/api.js
import axios from "axios";
import { DOMAINS } from "../constants/domains";
import { msalInstance } from "../auth/msal";
import { API_SCOPE } from "../auth/msal";

const api = axios.create({
  baseURL: DOMAINS.backend, // e.g. https://api.axillonaerospace.info
  withCredentials: true, // default for legacy cookie auth
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

/**
 * 🔐 Automatically adds Bearer token if user is signed in via Microsoft SSO.
 * Falls back to cookie-based auth otherwise.
 */
api.interceptors.request.use(async (config) => {
  try {
    const account = msalInstance.getAllAccounts()[0];

    if (account) {
      // Try to acquire a valid token silently
      const { accessToken } = await msalInstance.acquireTokenSilent({
        account,
        scopes: [API_SCOPE],
      });

      // Set Authorization header
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${accessToken}`;

      // SSO mode → don’t send cookies
      config.withCredentials = false;
    } else {
      // Legacy mode → rely on cookies
      config.withCredentials = true;
    }
  } catch (err) {
    console.warn("MSAL token fetch failed, falling back to cookies:", err);
    config.withCredentials = true;
  }

  return config;
});

export default api;